// extracted by mini-css-extract-plugin
export default {"statisticsWrapper":"cyclesStatistics_statisticsWrapper__+nNqc","statisticCard":"cyclesStatistics_statisticCard__SLY94"};